// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// This file is generated by scripts/generate-blog-index.js
// To regenerate, run: npm run generate:blog

import weekendHacksIpptPushups from './weekend-hacks-ippt-pushups.mdx';
import weekendHacksIpptPushupsRaw from './weekend-hacks-ippt-pushups.mdx?raw';
import orgStructureAiAgentEra from './org-structure-ai-agent-era.mdx';
import orgStructureAiAgentEraRaw from './org-structure-ai-agent-era.mdx?raw';
import rememberingGoodFriday from './remembering-good-friday.mdx';
import rememberingGoodFridayRaw from './remembering-good-friday.mdx?raw';
import effectiveOneOnOnes from './effective-one-on-ones.mdx';
import effectiveOneOnOnesRaw from './effective-one-on-ones.mdx?raw';
import techVisionDocuments from './tech-vision-documents.mdx';
import techVisionDocumentsRaw from './tech-vision-documents.mdx?raw';
import inferenceOptimisation from './inference-optimisation.mdx';
import inferenceOptimisationRaw from './inference-optimisation.mdx?raw';
import theCaseAgainstOrms from './the-case-against-orms.mdx';
import theCaseAgainstOrmsRaw from './the-case-against-orms.mdx?raw';
import aLookIntoPostgres from './a-look-into-postgres.mdx';
import aLookIntoPostgresRaw from './a-look-into-postgres.mdx?raw';
import welcomeToMyBlog from './welcome-to-my-blog.mdx';
import welcomeToMyBlogRaw from './welcome-to-my-blog.mdx?raw';

export const blogPosts = [
  {
    title: "Weekend Hacks: An IPPT Push-up Tester in Your Pocket",
    date: "2026-09-29",
    description: "Building a phone web app that counts push-ups out loud and calls no-counts like the IPPT machine",
    tags: ["weekend-hacks","computer-vision","typescript","side-projects"],
    slug: "weekend-hacks-ippt-pushups",
    component: weekendHacksIpptPushups,
    content: weekendHacksIpptPushupsRaw,
  },
  {
    title: "Org Structure for the AI Agent Era",
    date: "2026-07-11",
    description: "Why small senior-heavy teams, product-oriented engineers, and a deliberate junior pipeline win in the age of AI agents",
    tags: ["leadership","ai","engineering","org-design"],
    slug: "org-structure-ai-agent-era",
    component: orgStructureAiAgentEra,
    content: orgStructureAiAgentEraRaw,
  },
  {
    title: "Remembering Good Friday",
    date: "2026-04-03",
    description: "Reflections on creation, cherry blossoms, and the hope of Good Friday",
    tags: ["faith","musings"],
    slug: "remembering-good-friday",
    component: rememberingGoodFriday,
    content: rememberingGoodFridayRaw,
  },
  {
    title: "Running Effective One-on-Ones",
    date: "2025-12-11",
    description: "A framework for meaningful conversations with your team",
    tags: ["leadership","management","engineering"],
    slug: "effective-one-on-ones",
    component: effectiveOneOnOnes,
    content: effectiveOneOnOnesRaw,
  },
  {
    title: "Writing a Tech Vision Document",
    date: "2025-12-04",
    description: "A framework for clarifying strategy and aligning teams",
    tags: ["strategy","leadership","planning"],
    slug: "tech-vision-documents",
    component: techVisionDocuments,
    content: techVisionDocumentsRaw,
  },
  {
    title: "LLM Inference Optimisation Techniques",
    date: "2025-11-25",
    description: "Why software still matters more than hardware in the age of AI",
    tags: ["llm","inference","performance","ml-systems"],
    slug: "inference-optimisation",
    component: inferenceOptimisation,
    content: inferenceOptimisationRaw,
  },
  {
    title: "The Case Against ORMs",
    date: "2025-11-19",
    description: "A critical look at ORMs and why direct SQL often wins",
    tags: ["database","orms","sql"],
    slug: "the-case-against-orms",
    component: theCaseAgainstOrms,
    content: theCaseAgainstOrmsRaw,
  },
  {
    title: "A Deep Dive into Postgres",
    date: "2025-11-16",
    description: "Postgres: Powerful, Pragmatic, and Good Enough for Most Applications",
    tags: ["database","postgres"],
    slug: "a-look-into-postgres",
    component: aLookIntoPostgres,
    content: aLookIntoPostgresRaw,
  },
  {
    title: "Welcome to My Blog",
    date: "2025-11-11",
    description: "An introduction to my blog and what you can expect to find here.",
    tags: ["introduction"],
    slug: "welcome-to-my-blog",
    component: welcomeToMyBlog,
    content: welcomeToMyBlogRaw,
  }
];
